import { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";
import { PageHeader, TypeBadge, Loading, EmptyState } from "@/components/Shared";
import { Search, ExternalLink, Newspaper } from "lucide-react";

const TYPES = ["circulaire", "communique", "note", "alerte", "reglementation", "info", "avis"];

export default function News() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  const [type, setType] = useState("");

  const load = () => {
    const params = {};
    if (q) params.q = q;
    if (type) params.type = type;
    api.get("/news", { params }).then((r) => setItems(r.data)).catch(() => setItems([]));
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [type]);

  return (
    <div>
      <PageHeader title="Actualités professionnelles" subtitle="Circulaires, communiqués et alertes des organismes officiels." />

      <div className="bg-white border border-slate-200 rounded-xl p-4 mb-6 flex flex-col md:flex-row gap-3">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <input data-testid="news-search" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()}
            placeholder="Rechercher (médicament, organisme, mot-clé)..." className="w-full h-10 pl-9 pr-3 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 transition-shadow text-sm" />
        </div>
        <select value={type} onChange={(e) => setType(e.target.value)} data-testid="news-type-filter" className="h-10 px-3 rounded-lg border border-slate-300 text-sm font-medium bg-white capitalize">
          <option value="">Tous les types</option>
          {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>

      {items === null ? <Loading /> : items.length === 0 ? (
        <EmptyState title="Aucune publication" subtitle="Aucune actualité ne correspond à votre recherche." icon={Newspaper} />
      ) : (
        <div className="space-y-4">
          {items.map((n) => (
            <div key={n.id} className="bg-white border border-slate-200 rounded-xl p-5 hover:border-indigo-200 transition-colors duration-200" data-testid={`news-${n.id}`}>
              <div className="flex items-center gap-2 flex-wrap">
                <TypeBadge type={n.type} />
                <span className="text-xs font-semibold text-slate-500">{n.organism}</span>
                <span className="text-xs text-slate-400">· {fmtDate(n.date)}</span>
              </div>
              <h3 className="mt-2.5 font-bold text-slate-900">{n.title}</h3>
              <p className="mt-1.5 text-sm font-medium text-slate-600 leading-relaxed">{n.summary}</p>
              {n.source_url && (
                <a href={n.source_url} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-indigo-600 hover:underline">
                  <ExternalLink className="h-3.5 w-3.5" /> Source officielle
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
